export default __webpack_public_path__ + "static/media/README.c9b5db03.md";